import { render, staticRenderFns } from "./tradelist.vue?vue&type=template&id=78c9577e&scoped=true&"
import script from "./tradelist.vue?vue&type=script&lang=js&"
export * from "./tradelist.vue?vue&type=script&lang=js&"
import style0 from "./tradelist.vue?vue&type=style&index=0&id=78c9577e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9577e",
  null
  
)

export default component.exports